import {
  BooleanField,
  Datagrid,
  FunctionField,
  ListContextProvider,
  NumberField,
  SelectField,
  TextField,
  useList,
} from "react-admin";
import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography } from "@mui/material";
import { settings } from "app";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { CurriculumItemTypeChoices } from "utils/choices";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import UnmarkItemAsCompletedDialog from "./UnmarkItemAsCompletedDialog";
import UpdateEstimationsDialog from "./UpdateEstimationsDialog";
import { SpecialistStatuses } from "utils/constants";
import MarkItemAsCompletedDialog from "./MarkItemAsCompletedDialog";

const CurriculumModuleAccordion = ({
  module,
  index,
  specialistId,
  statusId,
  isTrainingBuildingExternal,
  fetchModules,
}) => {
  const listContext = useList({ data: module.items || [] });

  return (
    <Accordion sx={{ width: "100%" }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
        >
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              backgroundColor: "primary.main",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 14,
              flexShrink: 0,
            }}
          >
            {index + 1}
          </Box>

          <Typography
            fontWeight="bold"
            fontSize={16}
            color="primary"
          >
            {module.nameBg} ({module.items?.length ?? 0} теми)
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <ListContextProvider value={listContext}>
          <Typography sx={{ color: "#361B5C", fontWeight: 600, fontSize: 12 }}>Теми</Typography>
          <Datagrid
            bulkActionButtons={false}
            rowClick={false}
            sx={settings.style.secondaryLeftAlignedDatagrid}
          >
            <TextField
              source="nameBg"
              label="Наименование (БГ)"
              sortable={false}
            />
            <TextField
              source="nameEn"
              label="Наименование (EN)"
              sortable={false}
            />
            <SelectField
              source="type"
              label="Тип"
              choices={CurriculumItemTypeChoices}
              sortable={false}
            />
            <NumberField
              source="durationHours"
              label="Часове"
              sortable={false}
              emptyText="-"
              textAlign="left"
            />
            <TextField
              source="estimation"
              label="Оценка"
              emptyText="-"
            />
            <BooleanField
              source="isCompleted"
              label="Завършена?"
            />
            {statusId === SpecialistStatuses.Active && (
              <FunctionField
                label=""
                render={rec => (
                  <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                    <SecuredComponent permission={permissions.canManageSpecialistsCurriculumItemCompletions}>
                      {!rec.isCompleted ? (
                        <MarkItemAsCompletedDialog
                          specialistId={specialistId}
                          type={rec?.type}
                          curriculumItemId={rec?.id}
                          isTrainingBuildingExternal={isTrainingBuildingExternal}
                          fetchModules={fetchModules}
                        />
                      ) : (
                        <UnmarkItemAsCompletedDialog
                          specialistId={specialistId}
                          curriculumItemId={rec?.id}
                          fetchModules={fetchModules}
                        />
                      )}
                    </SecuredComponent>
                    <SecuredComponent permission={permissions.canManageSpecialistsCurriculumItemEstimations}>
                      <UpdateEstimationsDialog
                        specialistId={specialistId}
                        curriculumItemId={rec?.id}
                        fetchModules={fetchModules}
                      />
                    </SecuredComponent>
                  </Box>
                )}
              />
            )}
          </Datagrid>
        </ListContextProvider>
      </AccordionDetails>
    </Accordion>
  );
};
export default CurriculumModuleAccordion;
